import RunReportModalFeature from "./RunReportModalFeature";

export default RunReportModalFeature;
